import { useEffect, useState } from 'react'

export const useInfo = () => {
  const [modalActive, setModalActive] = useState(false)
  const [image, setImage] = useState<string>('')
  const [search, setSearch] = useState<string>('')

  const showScreenModal = (image: string) => {
    setImage(image)
    setModalActive(true)
  }

  const clearSearch = ()=>{
    setSearch('')
  }

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return { modalActive, setModalActive, image, showScreenModal, setSearch, clearSearch, search }
}
